export default __webpack_public_path__ + "static/media/elevate-gry-4.df74bd72.png";